module.exports = __webpack_public_path__ + "static/media/saved_mooring_marker.13c5c264.svg";